import { useNavigate } from "react-router-dom";
import Avatar from "./Avatar";

interface Treatment {
  id: string;
  name: string;
  date: string;
  time: string;
  treatment: string;
  detail?: string;
  avatarColor: string;
  status: "upcoming" | "in_progress";
}

const treatments: Treatment[] = [
  {
    id: "1",
    name: "Sarah Miller",
    date: "14/01/2026",
    time: "09:00",
    treatment: "Hydrafacial Treatment",
    detail: "Deep cleansing session",
    avatarColor: "purple",
    status: "upcoming",
  },
  {
    id: "2",
    name: "Emma Clark",
    date: "14/01/2026",
    time: "10:30",
    treatment: "PRP Facial Rejuvenation",
    detail: "Full face treatment",
    avatarColor: "pink",
    status: "upcoming",
  },
  {
    id: "3",
    name: "Rachel Adams",
    date: "14/01/2026",
    time: "11:45",
    treatment: "Dermal Fillers - Lips",
    detail: "0.5ml enhancement",
    avatarColor: "blue",
    status: "upcoming",
  },
  // {
  //   id: "4",
  //   name: "Laura Brown",
  //   date: "14/01/2026",
  //   time: "14:00",
  //   treatment: "Chemical Peel",
  //   detail: "TCA Medium Depth",
  //   avatarColor: "green",
  //   status: "upcoming",
  // },
  // {
  //   id: "5",
  //   name: "Sophie Anderson",
  //   date: "14/01/2026",
  //   time: "15:30",
  //   treatment: "Microneedling",
  //   detail: "Session 2 of 3",
  //   avatarColor: "orange",
  //   status: "upcoming",
  // },
];

const UpcomingTreatments = () => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate("/aesthetics/treatments?tab=upcoming");
  };

  const handleTreatmentClick = (treatmentId: string) => {
    navigate(`/aesthetics/treatments/${treatmentId}`);
  };

  return (
    <div className="bg-card rounded-2xl p-6 shadow-md">
      <div className="flex items-center justify-between mb-3 border-b border-gray-200 pb-3">
        <h2 className="text-lg font-semibold text-foreground">Upcoming Treatments</h2>
        <button 
          onClick={handleViewAll}
          className="text-[#704AAF] font-medium hover:underline"
        >
          View all
        </button>
      </div>
      <div className="space-y-4">
        {treatments.map((treatment) => (
          <div 
            key={treatment.id} 
            className="flex items-start gap-3 cursor-pointer hover:bg-gray-50 rounded-lg p-2 -mx-2 transition-colors"
            onClick={() => handleTreatmentClick(treatment.id)}
          >
            <Avatar name={treatment.name} color={treatment.avatarColor} />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="font-semibold text-foreground">{treatment.name}</span>
                <span className="text-muted-foreground text-sm ms-auto">{treatment.date}</span>
                <span className="text-[#704AAF] font-medium text-sm">{treatment.time}</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-muted-foreground mt-0.5">
                <span className="text-gray-600">{treatment.treatment}</span>
                {treatment.detail && (
                  <>
                    <span className="text-gray-400 ms-auto">{treatment.detail}</span>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpcomingTreatments;
